import { gql } from "@apollo/client";

export const GAME_CREATE = gql`
  mutation GameCreate($input: GameFieldsInput!) {
    gameCreate(input: $input) {
      label
      message
      game {
        id
        title
        link_site
        active
        placement
        row_order
      }
    }
  }
`;

export const GAME_UPDATE = gql`
  mutation GameUpdate($input: GameFieldsInput!) {
    gameUpdate(input: $input) {
      label
      message
      game {
        id
        title
        link_site
        active
        placement
        row_order
      }
    }
  }
`;

export const GAME_DELETE = gql`
  mutation GameDelete($id: ID!) {
    gameDelete(id: $id) {
      label
      message
    }
  }
`;

export const GAME_ORDER_UPDATE = gql`
  mutation GameOrderUpdate($input: GameFieldsInput!) {
    gameUpdate(input: $input) {
      game {
        id
        row_order
      }
    }
  }
`;
